import { useState } from "react";
import { Collapse } from "reactstrap";

import Icon from "../Icon/Icon";

const FAQSection = () => {
  const [open, setOpen] = useState(0);

  const items = [
    {
      title: "برای رزور هتل به چه مدارکی نیاز است؟",
      description:
        "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است.",
    },
    {
      title: "برای رزور هتل به چه مدارکی نیاز است؟",
      description:
        "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است.",
    },
    {
      title: "برای رزور هتل به چه مدارکی نیاز است؟",
      description:
        "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است.",
    },
    {
      title: "برای رزور هتل به چه مدارکی نیاز است؟",
      description:
        "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است.",
    },
  ];
  return (
    <>
      <div className="d-flex align-items-center mb-4">
        <div className="bg-gray-dim rounded-pill p-2">
          <img
            src="/assets/images/icons/question.png"
            alt=""
            width="50"
            height="50"
          />
        </div>
        <h3 className="fw-bold ml-4 text-dark">سوالات متداول</h3>
      </div>
      {items.map((item, index) => (
        <div className="bg-gray-dim rounded-pill mb-2 p-3" key={index}>
          <div
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => setOpen(index)}
          >
            <h6 className="fw-bold text-dark m-0">{item.title}</h6>
            <Icon
              name={open === index ? "chevron-up" : "chevron-down"}
              className="text-orange fa-2x"
            />
          </div>
          <Collapse className="accordion-body" isOpen={open === index}>
            <div className="accordion-inner">
              <p>{item.description}</p>
            </div>
          </Collapse>
        </div>
      ))}
    </>
  );
};

export default FAQSection;
